<template>
    <div class="row">
        <div class="col-12">
            <block-header
                :overline="header.overline"
                :title="header.title"
                :subtitle="header.subTitle"
            />
        </div>
        <div class="col-12" :class="imagePosition === 'top' ? 'order-3' : 'mb-2'">
            <vue-markdown :source="imageText" />
        </div>
        <div class="col-12 d-flex align-items-center justify-content-center" :class="imagePosition === 'top' ? 'mb-3' : ''">
            <b-img :src="image" class="image" :alt="altText ? altText : ''"/>
        </div>
    </div>
</template>

<script>
    import BlockHeader from "../../../molecules/BlockHeader";
    import VueMarkdown from "vue-markdown";

    export default {
        name: "TextWithImageVertical",
        components: { BlockHeader, VueMarkdown },
        props: {
            header: Object,
            imageText: String,
            image: String,
            imagePosition: String,
            altText: String
        }
    }
</script>

<style scoped>
    .image {
        max-height: 360px;
        width: auto;
        max-width: 100%;
    }
</style>
